export const TYPE_LIST_ITEM = 'list-item';
export const TYPE_ORDERED_LIST = 'ordered-list';
export const TYPE_UNORDERED_LIST = 'unordered-list';
export const TYPE_CHECKLIST = 'check-list';
